import Dialog from './components/Dialog';

export default Dialog;
